var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _g4, _path10, _path11, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 246,
    viewBox: "0 0 179 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9 19.1856C92.1445 1.9733 100.883 5.46116 112.043 8.20756C123.202 10.954 132.539 11.93 128.302 29.1423C124.065 46.3546 108.691 69.7935 97.5314 67.0396C86.3717 64.2856 83.648 36.3979 87.9 19.1856Z",
    fill: "url(#paint0_linear_442_107)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9 19.1856C92.1445 1.9733 100.883 5.46116 112.043 8.20756C123.202 10.954 132.539 11.93 128.302 29.1423C124.065 46.3546 108.691 69.7935 97.5314 67.0396C86.3717 64.2856 83.648 36.3979 87.9 19.1856Z",
    fill: "url(#paint1_linear_442_107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9263 19.1856C86.6819 1.9733 77.9433 5.46116 66.7837 8.20756C55.6241 10.954 46.2651 11.93 50.5096 29.1423C54.754 46.3546 70.1203 69.7935 81.2799 67.0396C92.4395 64.2856 95.1405 36.3979 90.9263 19.1856Z",
    fill: "url(#paint2_linear_442_107)",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9263 19.1856C86.6819 1.9733 77.9433 5.46116 66.7837 8.20756C55.6241 10.954 46.2651 11.93 50.5096 29.1423C54.754 46.3546 70.1203 69.7935 81.2799 67.0396C92.4395 64.2856 95.1405 36.3979 90.9263 19.1856Z",
    fill: "url(#paint3_linear_442_107)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 176.888C178.41 201.452 168.462 218.497 152.393 229.418C136.304 240.353 114.042 245.17 89.398 245.17C64.7545 245.17 42.4906 240.353 26.399 229.418C10.3286 218.497 0.378292 201.452 0.378292 176.888C0.378292 152.291 10.355 121.616 26.5014 97.0919C42.6559 72.5551 64.9099 54.2835 89.4132 54.2835C113.916 54.2835 136.161 72.5532 152.306 97.089C168.443 121.612 178.41 152.287 178.41 176.888Z",
    fill: "url(#paint4_linear_442_107)",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 176.888C178.41 201.452 168.462 218.497 152.393 229.418C136.304 240.353 114.042 245.17 89.398 245.17C64.7545 245.17 42.4906 240.353 26.399 229.418C10.3286 218.497 0.378292 201.452 0.378292 176.888C0.378292 152.291 10.355 121.616 26.5014 97.0919C42.6559 72.5551 64.9099 54.2835 89.4132 54.2835C113.916 54.2835 136.161 72.5532 152.306 97.089C168.443 121.612 178.41 152.287 178.41 176.888Z",
    fill: "url(#paint5_linear_442_107)",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 176.888C178.41 201.452 168.462 218.497 152.393 229.418C136.304 240.353 114.042 245.17 89.398 245.17C64.7545 245.17 42.4906 240.353 26.399 229.418C10.3286 218.497 0.378292 201.452 0.378292 176.888C0.378292 152.291 10.355 121.616 26.5014 97.0919C42.6559 72.5551 64.9099 54.2835 89.4132 54.2835C113.916 54.2835 136.161 72.5532 152.306 97.089C168.443 121.612 178.41 152.287 178.41 176.888Z",
    fill: "url(#paint6_linear_442_107)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 176.888C178.41 201.452 168.462 218.497 152.393 229.418C136.304 240.353 114.042 245.17 89.398 245.17C64.7545 245.17 42.4906 240.353 26.399 229.418C10.3286 218.497 0.378292 201.452 0.378292 176.888C0.378292 152.291 10.355 121.616 26.5014 97.0919C42.6559 72.5551 64.9099 54.2835 89.4132 54.2835C113.916 54.2835 136.161 72.5532 152.306 97.089C168.443 121.612 178.41 152.287 178.41 176.888Z",
    stroke: "url(#paint7_linear_442_107)",
    strokeWidth: 0.756585
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41 176.888C178.41 201.452 168.462 218.497 152.393 229.418C136.304 240.353 114.042 245.17 89.398 245.17C64.7545 245.17 42.4906 240.353 26.399 229.418C10.3286 218.497 0.378292 201.452 0.378292 176.888C0.378292 152.291 10.355 121.616 26.5014 97.0919C42.6559 72.5551 64.9099 54.2835 89.4132 54.2835C113.916 54.2835 136.161 72.5532 152.306 97.089C168.443 121.612 178.41 152.287 178.41 176.888Z",
    stroke: "url(#paint8_radial_442_107)",
    strokeWidth: 0.756585
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_442_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5844 16.4543C68.5844 -1.28001 77.898 0.021313 89.398 0.021313C100.898 0.021313 110.204 -1.28001 110.204 16.4543C110.204 34.1887 100.891 60.6086 89.398 60.6086C77.9055 60.6086 68.5844 34.1811 68.5844 16.4543Z",
    fill: "url(#paint9_linear_442_107)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9627 16.4543C68.9627 7.64176 71.2738 3.72089 74.8485 1.92549C76.6642 1.01353 78.8468 0.626535 81.3178 0.472641C83.1468 0.358729 85.1066 0.373303 87.1721 0.388663C87.9013 0.394085 88.6436 0.399605 89.3981 0.399605C90.1525 0.399605 90.8948 0.394084 91.624 0.388662C93.6893 0.373303 95.6486 0.358731 97.4771 0.47264C99.9474 0.626534 102.129 1.01353 103.944 1.92546C107.517 3.72081 109.826 7.64162 109.826 16.4543C109.826 25.2669 107.509 36.2551 103.763 45.0334C101.89 49.4224 99.6679 53.2379 97.2168 55.9497C94.7618 58.6657 92.1189 60.2303 89.3981 60.2303C86.6772 60.2303 84.0338 58.6653 81.5781 55.9486C79.1263 53.2362 76.9035 49.42 75.0294 45.0305C71.2812 36.2513 68.9627 25.2631 68.9627 16.4543Z",
    stroke: "url(#paint10_linear_442_107)",
    strokeWidth: 0.756585
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9627 16.4543C68.9627 7.64176 71.2738 3.72089 74.8485 1.92549C76.6642 1.01353 78.8468 0.626535 81.3178 0.472641C83.1468 0.358729 85.1066 0.373303 87.1721 0.388663C87.9013 0.394085 88.6436 0.399605 89.3981 0.399605C90.1525 0.399605 90.8948 0.394084 91.624 0.388662C93.6893 0.373303 95.6486 0.358731 97.4771 0.47264C99.9474 0.626534 102.129 1.01353 103.944 1.92546C107.517 3.72081 109.826 7.64162 109.826 16.4543C109.826 25.2669 107.509 36.2551 103.763 45.0334C101.89 49.4224 99.6679 53.2379 97.2168 55.9497C94.7618 58.6657 92.1189 60.2303 89.3981 60.2303C86.6772 60.2303 84.0338 58.6653 81.5781 55.9486C79.1263 53.2362 76.9035 49.42 75.0294 45.0305C71.2812 36.2513 68.9627 25.2631 68.9627 16.4543Z",
    stroke: "url(#paint11_radial_442_107)",
    strokeWidth: 0.756585
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_442_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5103 61.9628C78.5107 50.9924 100.595 52.3315 117.868 61.9628C121.984 64.2326 125.676 57.9454 121.56 55.6529C102.093 44.7959 76.9976 43.2752 57.8257 55.6529C53.8537 58.2253 57.5382 64.5277 61.5103 61.9628Z",
    fill: "url(#paint12_linear_442_107)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3051 61.645L61.3052 61.645C78.4463 50.5838 100.683 51.9477 118.052 61.6321C118.987 62.1475 119.876 62.1697 120.634 61.9004C121.4 61.6279 122.052 61.048 122.475 60.3274C122.897 59.6066 123.076 58.7693 122.927 57.9965C122.781 57.2347 122.312 56.5044 121.376 55.9834L121.376 55.9833C102.005 45.1798 77.0622 43.684 58.0314 55.9705L61.3051 61.645ZM61.3051 61.645C60.4017 62.2283 59.5439 62.2943 58.816 62.0605M61.3051 61.645L58.816 62.0605M58.816 62.0605C58.0769 61.8232 57.4372 61.2651 57.0156 60.5435M58.816 62.0605L57.0156 60.5435M57.0156 60.5435C56.1712 59.0983 56.2542 57.1217 58.0309 55.9707L57.0156 60.5435Z",
    stroke: "url(#paint13_linear_442_107)",
    strokeWidth: 0.756585
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3051 61.645L61.3052 61.645C78.4463 50.5838 100.683 51.9477 118.052 61.6321C118.987 62.1475 119.876 62.1697 120.634 61.9004C121.4 61.6279 122.052 61.048 122.475 60.3274C122.897 59.6066 123.076 58.7693 122.927 57.9965C122.781 57.2347 122.312 56.5044 121.376 55.9834L121.376 55.9833C102.005 45.1798 77.0622 43.684 58.0314 55.9705L61.3051 61.645ZM61.3051 61.645C60.4017 62.2283 59.5439 62.2943 58.816 62.0605M61.3051 61.645L58.816 62.0605M58.816 62.0605C58.0769 61.8232 57.4372 61.2651 57.0156 60.5435M58.816 62.0605L57.0156 60.5435M57.0156 60.5435C56.1712 59.0983 56.2542 57.1217 58.0309 55.9707L57.0156 60.5435Z",
    stroke: "url(#paint14_radial_442_107)",
    strokeWidth: 0.756585
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_442_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.64 47.6332V87.4749C101.64 92.1884 108.948 92.1884 108.948 87.4749V47.6332C108.948 42.9196 101.64 42.9196 101.64 47.6332Z",
    fill: "url(#paint15_linear_442_107)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.018 87.4749V47.6332C102.018 46.5619 102.429 45.784 103.028 45.2686C103.635 44.7465 104.458 44.4763 105.294 44.4763C106.13 44.4763 106.952 44.7465 107.56 45.2686C108.159 45.784 108.57 46.5619 108.57 47.6332V87.4749C108.57 88.5462 108.159 89.3241 107.56 89.8394C106.952 90.3615 106.13 90.6318 105.294 90.6318C104.458 90.6318 103.635 90.3615 103.028 89.8394C102.429 89.3241 102.018 88.5462 102.018 87.4749Z",
    stroke: "url(#paint16_linear_442_107)",
    strokeWidth: 0.756585
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.018 87.4749V47.6332C102.018 46.5619 102.429 45.784 103.028 45.2686C103.635 44.7465 104.458 44.4763 105.294 44.4763C106.13 44.4763 106.952 44.7465 107.56 45.2686C108.159 45.784 108.57 46.5619 108.57 47.6332V87.4749C108.57 88.5462 108.159 89.3241 107.56 89.8394C106.952 90.3615 106.13 90.6318 105.294 90.6318C104.458 90.6318 103.635 90.3615 103.028 89.8394C102.429 89.3241 102.018 88.5462 102.018 87.4749Z",
    stroke: "url(#paint17_radial_442_107)",
    strokeWidth: 0.756585
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_442_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8757 45.8098V57.3175C94.8757 62.031 102.184 62.031 102.184 57.3175V45.8098C102.184 41.0887 94.8757 41.0887 94.8757 45.8098Z",
    fill: "url(#paint18_linear_442_107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.254 57.3175V45.8098C95.254 44.7364 95.6652 43.957 96.2646 43.4408C96.8717 42.9179 97.6939 42.6473 98.53 42.6473C99.3662 42.6473 100.188 42.9179 100.795 43.4408C101.395 43.957 101.806 44.7364 101.806 45.8098V57.3175C101.806 58.3887 101.395 59.1667 100.796 59.682C100.189 60.2041 99.3663 60.4743 98.53 60.4743C97.6937 60.4743 96.8715 60.2041 96.2643 59.682C95.6651 59.1667 95.254 58.3887 95.254 57.3175Z",
    stroke: "url(#paint19_linear_442_107)",
    strokeWidth: 0.756585
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.254 57.3175V45.8098C95.254 44.7364 95.6652 43.957 96.2646 43.4408C96.8717 42.9179 97.6939 42.6473 98.53 42.6473C99.3662 42.6473 100.188 42.9179 100.795 43.4408C101.395 43.957 101.806 44.7364 101.806 45.8098V57.3175C101.806 58.3887 101.395 59.1667 100.796 59.682C100.189 60.2041 99.3663 60.4743 98.53 60.4743C97.6937 60.4743 96.8715 60.2041 96.2643 59.682C95.6651 59.1667 95.254 58.3887 95.254 57.3175Z",
    stroke: "url(#paint20_radial_442_107)",
    strokeWidth: 0.756585
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.476 110C107.113 110 105.198 111.915 105.198 114.279V159.847V133.903C105.198 133.903 102.128 131.861 98.0441 130.498C94.9944 129.481 91.1587 129.039 88.808 129.039C71.8297 129.039 58 142.869 58 159.847C58 176.825 71.8297 190.655 88.808 190.655C105.786 190.655 119 176.825 119 159.847V114.279C119 111.915 117.085 110 114.722 110H109.476ZM88.9273 142.784C98.3763 142.784 105.136 150.398 105.136 159.847C105.136 164.257 103.663 168.269 101.131 171.292C98.2389 174.747 93.9658 176.911 88.9273 176.911C79.4784 176.911 71.8636 169.296 71.8635 159.847C71.8635 150.398 79.4784 142.783 88.9273 142.784Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.808 129.039C71.8297 129.039 58 142.869 58 159.847C58 176.825 71.8297 190.655 88.808 190.655C105.786 190.655 119 176.825 119 159.847H105.198V133.903C104.737 133.601 104.517 133.435 103.79 133.035C99.3503 130.591 94.3066 129.039 88.808 129.039ZM88.9273 142.783C98.3763 142.783 105.136 150.398 105.136 159.847C105.136 164.257 103.663 168.269 101.131 171.292C98.2389 174.746 93.9658 176.91 88.9273 176.91C79.4784 176.91 71.8636 169.296 71.8635 159.847C71.8635 150.398 79.4785 142.783 88.9273 142.783Z",
    fill: "url(#paint21_radial_442_107)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_442_107)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.476 110C107.113 110 105.198 111.915 105.198 114.278V159.847V133.903C105.198 133.903 102.128 131.861 98.0441 130.498C94.9944 129.48 91.1587 129.039 88.808 129.039C71.8297 129.039 58 142.869 58 159.847C58 176.825 71.8297 190.655 88.808 190.655C105.786 190.655 119 176.825 119 159.847V114.278C119 111.915 117.085 110 114.722 110H109.476ZM88.9273 142.783C98.3763 142.783 105.136 150.398 105.136 159.847C105.136 164.257 103.663 168.269 101.131 171.292C98.2389 174.747 93.9658 176.911 88.9273 176.911C79.4784 176.911 71.8636 169.296 71.8635 159.847C71.8635 150.398 79.4784 142.783 88.9273 142.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.476 110C107.113 110 105.198 111.915 105.198 114.278V159.847V133.903C105.198 133.903 102.128 131.861 98.0441 130.498C94.9944 129.48 91.1587 129.039 88.808 129.039C71.8297 129.039 58 142.869 58 159.847C58 176.825 71.8297 190.655 88.808 190.655C105.786 190.655 119 176.825 119 159.847V114.278C119 111.915 117.085 110 114.722 110H109.476ZM88.9273 142.783C98.3763 142.783 105.136 150.398 105.136 159.847C105.136 164.257 103.663 168.269 101.131 171.292C98.2389 174.747 93.9658 176.911 88.9273 176.911C79.4784 176.911 71.8636 169.296 71.8635 159.847C71.8635 150.398 79.4784 142.783 88.9273 142.783Z",
    fill: "url(#paint22_linear_442_107)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.808 129.039C71.8297 129.039 58 142.869 58 159.847C58 176.825 71.8297 190.655 88.808 190.655C105.786 190.655 119 176.825 119 159.847H105.198V133.903C104.737 133.601 104.517 133.435 103.79 133.035C99.3503 130.591 94.3066 129.039 88.808 129.039ZM88.9273 142.783C98.3763 142.783 105.136 150.398 105.136 159.847C105.136 164.257 103.663 168.269 101.131 171.292C98.2389 174.746 93.9658 176.91 88.9273 176.91C79.4784 176.91 71.8636 169.296 71.8635 159.847C71.8635 150.398 79.4785 142.783 88.9273 142.783Z",
    fill: "url(#paint23_radial_442_107)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_442_107",
    x: 65.4983,
    y: -3.08613,
    width: 47.792,
    height: 66.7809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.54307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_442_107",
    x: 53.0328,
    y: 43.8445,
    width: 73.4104,
    height: 21.8065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.54307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_442_107",
    x: 98.5534,
    y: 41.0119,
    width: 13.4809,
    height: 53.0843,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.54307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_442_107",
    x: 91.7896,
    y: 39.1829,
    width: 13.4809,
    height: 24.7559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.54307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_442_107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_442_107",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_442_107",
    x: 58,
    y: 110,
    width: 61,
    height: 83.6552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_442_107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_442_107",
    x1: 125.46,
    y1: 60.2264,
    x2: 78.2752,
    y2: 25.0189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_442_107",
    x1: 125.46,
    y1: 60.2264,
    x2: 78.2752,
    y2: 25.0189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_442_107",
    x1: 88.9272,
    y1: 60.2264,
    x2: 41.7438,
    y2: 25.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_442_107",
    x1: 88.9272,
    y1: 60.2264,
    x2: 41.7438,
    y2: 25.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_442_107",
    x1: 162.769,
    y1: 223.566,
    x2: 8.99102,
    y2: 72.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_442_107",
    x1: 162.769,
    y1: 223.566,
    x2: 8.99102,
    y2: 72.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_442_107",
    x1: 162.769,
    y1: 223.566,
    x2: 8.99102,
    y2: 72.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_442_107",
    x1: 89.3943,
    y1: 29.1543,
    x2: 145.47,
    y2: 266.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.36 217.385) rotate(-146.353) scale(75.037 45.1541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_442_107",
    x1: 106.475,
    y1: 53.6566,
    x2: 60.2469,
    y2: 20.1411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_442_107",
    x1: 89.3943,
    y1: -7.82768,
    x2: 112.459,
    y2: 64.1181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.026 51.7018) rotate(-137.879) scale(19.6046 12.7238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_442_107",
    x1: 117.333,
    y1: 60.7715,
    x2: 112.062,
    y2: 36.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_442_107",
    x1: 89.738,
    y1: 44.9114,
    x2: 90.7829,
    y2: 65.3239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.529 60.2673) rotate(-171.784) scale(23.7354 4.37961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_442_107",
    x1: 108.293,
    y1: 85.6291,
    x2: 96.2347,
    y2: 83.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_442_107",
    x1: 105.294,
    y1: 38.0393,
    x2: 134.251,
    y2: 58.5322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.336 84.116) rotate(-104.085) scale(10.4929 3.2312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_442_107",
    x1: 101.529,
    y1: 58.721,
    x2: 90.9659,
    y2: 54.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_442_107",
    x1: 98.53,
    y1: 39.8689,
    x2: 108.898,
    y2: 58.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.573 58.1216) rotate(-122.349) scale(4.77228 2.81436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.662 132.427) scale(60.6791 60.6791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212",
    stopOpacity: 0.476377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110106,
    stopColor: "#121212",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_442_107",
    x1: 65.6031,
    y1: 182.876,
    x2: 124.757,
    y2: 120.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138896,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409778,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789331,
    stopColor: "#5B5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927362,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_442_107",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.662 132.427) scale(60.6791 60.6791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212",
    stopOpacity: 0.476377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110106,
    stopColor: "#121212",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/Earn.3f7c92bc7f14cae043346c2f367f1b4e.svg";
export { ForwardRef as ReactComponent };